export default __webpack_public_path__ + "static/media/cs50x.774fb897.png";